import Dialog from "@mui/material/Dialog";
import {
	CartTemplateModalBody,
	CartTemplateModalButtons,
	CartTemplateModalHeader
} from "features/MarketingMaterials/pages/Checkout/components/ViewCartModals/CartTemplateModal.styles.ts";
import Close from "@mui/icons-material/Close";
import { Button } from "@mui/material";

export interface EmptyCartModalProps {
	isOpen: boolean;
	onClose: () => void;
	onSubmit: () => Promise<void>;
}

export const EmptyCartModal = ({ isOpen, onClose, onSubmit }: EmptyCartModalProps) => {
	const handleClose = () => {
		onClose();
	};

	const handleSubmit = async () => {
		await onSubmit();
		onClose();
	};

	return (
		<Dialog
			open={isOpen}
			onClose={handleClose}
			fullWidth
			maxWidth="sm"
		>
			<CartTemplateModalHeader>
				<div>
					<h6>Are you sure you&#39;d like to empty your cart?</h6>
				</div>
				<Close onClick={handleClose} />
			</CartTemplateModalHeader>
			<CartTemplateModalBody isError={false}>
				<CartTemplateModalButtons>
					<Button
						variant="outlined"
						onClick={handleClose}
					>
						Cancel
					</Button>
					<Button
						variant="contained"
						onClick={handleSubmit}
					>
						Yes, Empty Cart
					</Button>
				</CartTemplateModalButtons>
			</CartTemplateModalBody>
		</Dialog>
	);
};
